var map = {
	"./blob-1.svg": 8963,
	"./blob-2.svg": 8534,
	"./blob-3.svg": 7488,
	"./blob-4.svg": 5977,
	"./blob-5.svg": 5208,
	"./food-tech-connect.png": 2487,
	"./icon--cloud.svg": 2782,
	"./icon--cost.svg": 4061,
	"./icon--help.svg": 9684,
	"./icon--ingredients.svg": 520,
	"./icon--list.svg": 1422,
	"./icon--recipe-mgmt.svg": 4988,
	"./icon--timer.svg": 7517,
	"./illustration--cost-analysis.svg": 474,
	"./illustration--ingredient-list.png": 2967,
	"./illustration--main-labels.png": 2633,
	"./illustration--main-labels.svg": 1340,
	"./industries/bakery@1x.webp": 7365,
	"./industries/bakery@2x.webp": 8897,
	"./industries/bakery@3x.webp": 89,
	"./industries/bakery@4x.webp": 4122,
	"./industries/copacker@1x.webp": 6440,
	"./industries/copacker@2x.webp": 6804,
	"./industries/copacker@3x.webp": 4366,
	"./industries/copacker@4x.webp": 8706,
	"./industries/food-biz@1x.webp": 9403,
	"./industries/food-biz@2x.webp": 1900,
	"./industries/food-biz@3x.webp": 3782,
	"./industries/food-biz@4x.webp": 1730,
	"./industries/nutritionist@1x.webp": 639,
	"./industries/nutritionist@2x.webp": 1770,
	"./industries/nutritionist@3x.webp": 9720,
	"./industries/nutritionist@4x.webp": 7111,
	"./industries/restaurant@1x.webp": 8862,
	"./industries/restaurant@2x.webp": 6757,
	"./industries/restaurant@3x.webp": 1107,
	"./industries/restaurant@4x.webp": 8704,
	"./industries/school@1x.webp": 3472,
	"./industries/school@2x.webp": 9924,
	"./industries/school@3x.webp": 4563,
	"./industries/school@4x.webp": 6882,
	"./logos/avery.png": 5796,
	"./logos/blume.png": 4254,
	"./logos/gumvees.png": 5070,
	"./logos/harney-tea.png": 5312,
	"./logos/immi.png": 3033,
	"./logos/lesser-evil.png": 6871,
	"./logos/luna-mexican-kitchen.png": 2268,
	"./logos/magnolia-bakery.svg": 3116,
	"./logos/mollys-herbals.png": 6251,
	"./logos/sakara.svg": 1762,
	"./logos/saucy-rebellion.png": 791,
	"./logos/secret-sauce-test-kitchen.png": 8829,
	"./logos/treehouse-foods.png": 8056,
	"./logos/union-kitchen.png": 9793,
	"./logos/yellowbird.png": 5598,
	"./screenshot--labeling.png": 3501,
	"./small-batch-america.png": 4512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2820;